
























import { Vue, Component, Prop, Inject } from "vue-property-decorator";
import { IAccount } from "@/models/accounts";
import {
  IAffiliateProvider,
  IAffiliateProviderMethods
} from "@/models/providers/affiliate";
import { CreateElement } from "vue";
import i18n from "@/i18n";

@Component({
  components: {
    "commissions-history-table": () =>
      import("@/components/app/global/affiliate/commissionsHistoryTable.vue"),
    "payout-destinations-provider": () =>
      import("@/components/app/global/affiliate/payoutDestinationsProvider.vue")
  }
})
export default class AdminClientAffiliateOverviewView extends Vue {
  // Inject

  @Inject({ from: "affiliateProviderMethods" })
  public readonly $affiliateMethods!: IAffiliateProviderMethods;

  @Inject({ from: "affiliateProvider" })
  public readonly $affiliateData!: () => IAffiliateProvider;

  // Props

  @Prop({ required: true })
  public accountId!: IAccount["id"];

  // Computed

  public get hasPayableCommissions() {
    return this.$affiliateData().hasPayableCommissions;
  }

  public get brandId() {
    return this.$affiliateData().affiliate?.account?.brand_id;
  }

  public get payoutButton() {
    return {
      render: (h: CreateElement) => {
        const btn = h(
          "b-button",
          {
            attrs: {
              disabled: !this.hasPayableCommissions
            },
            on: {
              click: () => {
                this.$affiliateMethods.openCommissionPayoutModal({
                  parent: this.$refs?.affPDsProvider
                });
              }
            }
          },
          [i18n.t("_action.payout_commissions") as string]
        );

        if (this.hasPayableCommissions) return btn;
        return h(
          "b-tooltip",
          {
            props: {
              label: i18n.t("_sentence.affiliate.no_available_commissions_msg"),
              multilined: true,
              type: "is-dark",
              size: "is-small"
            }
          },
          [btn]
        );
      }
    };
  }
}
